import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Bonuses } from './components/Bonuses';
import { ForYou } from './components/ForYou';
import { Results } from './components/Results';
import { PurchaseSection } from './components/PurchaseSection';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-emerald-200 selection:text-emerald-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Benefits data-id="element-5" />
        <WhatsIncluded data-id="element-6" />
        <Bonuses data-id="element-7" />
        <ForYou data-id="element-8" />
        <Results data-id="element-9" />
        <PurchaseSection data-id="element-10" />
        <Testimonials data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}